export class WarningMessageWithButtonViewModel {
  public static createEmpty(): WarningMessageWithButtonViewModel {
    return new WarningMessageWithButtonViewModel();
  }
  constructor(public Text: string = '', public ButtonText: string = '') { }
}
